var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.32 4.68c-2.895-2.892-6.892-4.68-11.307-4.68-8.837 0-16 7.163-16 16s7.163 16 16 16c4.415 0 8.413-1.788 11.308-4.68l-0 0c2.899-2.896 4.693-6.899 4.693-11.32s-1.793-8.424-4.692-11.32l-0-0zM6.2 6.2c2.502-2.51 5.964-4.063 9.787-4.063 3.452 0 6.608 1.266 9.030 3.358l-0.018-0.015-19.52 19.52c-2.078-2.404-3.343-5.561-3.343-9.013 0-3.824 1.553-7.285 4.063-9.787l0-0zM25.8 25.8c-2.502 2.51-5.964 4.063-9.787 4.063-3.452 0-6.608-1.266-9.030-3.358l0.018 0.015 19.52-19.52c2.078 2.404 3.343 5.561 3.343 9.013 0 3.824-1.553 7.285-4.063 9.787l-0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.83f2112e1b17a5ee0b24941654fd34ed.svg";
export { ForwardRef as ReactComponent };